import React from "react";
import { Link } from "react-router-dom";
import { ProductConsumer } from "../context";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { ProductWrapper } from "./styles/ProductWrapper";

export default function Product({ product }) {
  // TODO: Fix undefined item
  if (!product) {
    return null;
  } else {
    const { id, title, img, price, inCart } = product;

    return (
      <ProductWrapper className="col-9 mx-auto col-md-6 col-lg-3 my-3">
        <div className="card">
          <ProductConsumer>
            {({ handleDetail, addToCart, openModal }) => (
              <div
                className="img-container p-5"
                onClick={() => handleDetail(id)}
              >
                <Link to="/details">
                  <img src={img} alt={title} className="card-img-top" />
                </Link>
                <button
                  className="btn cart-btn"
                  disabled={inCart ? true : false}
                  onClick={() => {
                    addToCart(id);
                    openModal(id);
                  }}
                >
                  {inCart ? (
                    <p className="text-capitalize mb-0 disabled">in cart</p>
                  ) : (
                    <FontAwesomeIcon icon={faPlus} className="add-icon" />
                  )}
                </button>
              </div>
            )}
          </ProductConsumer>
          <div className="card-footer d-flex justify-content-between">
            <p className="align-self-center mb-0">{title}</p>
            <h5 className="text-blue font-italic mb-0">
              <span className="mr-1">$</span>
              {price}
            </h5>
          </div>
        </div>
      </ProductWrapper>
    );
  }
}

Product.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.number,
    img: PropTypes.string,
    title: PropTypes.string,
    price: PropTypes.number,
    inCart: PropTypes.bool
  }).isRequired
};
